// @flow

import type { Merchant, MerchantConfig } from '@tectonics/prs/merchant/types';

export function getMerchantConfig(merchant: Merchant): ?MerchantConfig {
  return merchant['config'];
}
